var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-select',_vm._b({staticClass:"mr-3 ma-auto dropdown-wrapper custom-border-box",attrs:{"flat":"","solo":"","hide-details":"","loading":_setup.loading,"items":_setup.groupNames,"label":_vm.$t('groupBy')},on:{"change":function($event){return _vm.$emit('update:value', $event)}}},'v-select',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }